import { createApiEndpoints, FuncEndpoint, P1 } from '../utils';

const PREFIX_V1CRA = '/v1/cra/web';

const ENDPOINTS_V1CRA = [
  `/entity/${P1}/dataleaks`,
  `/entity/${P1}/domains`,
  `/entity/${P1}/findings`,
  `/entity/${P1}/honeypots`,
  `/entity/${P1}/ip_addresses`,
  `/entity/${P1}/list`,
  `/entity/${P1}/scans`,
  `/entity/${P1}/stats`,
  `/entity/${P1}/status`,
  `/entity/${P1}/techs`,
  `/entity/${P1}/torrents`,
  `/entity/${P1}`,
  `/list`,
  `/trigger`,
] as const;

type Endpoints = (typeof ENDPOINTS_V1CRA)[number];

export type EndpointsV1CRA = Record<Endpoints, FuncEndpoint>;

export const endpointsV1CRA = createApiEndpoints<Endpoints>(
  PREFIX_V1CRA,
  ENDPOINTS_V1CRA,
) as EndpointsV1CRA;
